import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import CloseInCircleIcon from '@icons/CloseInCircleIcon';
import { ItemOption } from '@models/item';
import { OrderOption } from '@models/order';
import useOptionControl from '@store/item/hooks/useOptionControl';
import { useTranslation } from 'react-i18next';

interface Props {
    orderOption: OrderOption;
    itemOption: ItemOption;
    optionGroupId: string;
    itemId: string;
}

function SelectedOptionRow({
    orderOption, itemOption, optionGroupId, itemId,
}:Props) {
    const { t } = useTranslation('item');
    const { optionName, quantity, optionPrice } = orderOption;
    const { removeOption } = useOptionControl({ itemId });
    return (
        <Row spacing={4}>
            <Text>{optionName} ({quantity.toLocaleString()})</Text>
            <Text color={colors.gray5}>
                {t('option.pricePrefix')}{(optionPrice * quantity).toLocaleString()}{t('footer.priceUnit')}
            </Text>
            <CloseInCircleIcon color={colors.gray4}
                onClick={() => removeOption({ option: itemOption, optionGroupId })} />
        </Row>
    );
}

export default SelectedOptionRow;
